(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name adminCommanderDiscretion.controller:AdminCommanderDiscretionCtrl
   *
   * @description
   *
   */
  angular
    .module('adminCommanderDiscretion')
    .directive('focusOn',function($timeout) {
		return {
			restrict : 'A',
			link : function(vm,$element,$attr) {
				vm.$watch($attr.focusOn,function(_focusVal) {
					$timeout(function() {
						_focusVal ? $element[0].focus() : $element[0].blur();
					});
				});
			}
		}
	})
    .controller('AdminCommanderDiscretionCtrl', AdminCommanderDiscretionCtrl);

  function AdminCommanderDiscretionCtrl(EventManagerService,AdminCommanderDiscretionService,MessageService,PopupManager,applicationConstants, StorageServices) {
    var vm = this;
    vm.ctrlName = 'AdminCommanderDiscretionCtrl';

    vm.model = {
    	searchOnGoing : false,
    	searchPanelToggle:true,
    	initialSearchDone: false,
    	editorMode:applicationConstants.EDITOR_STATUS.ADD,
    	searchCriteria:{
    		cdr : null,
    		sector:null,
    		submitedBy : null,
    		approvedBy : null,
    		status : null,
    		dateOccurred : null,
    		dateGCAASubmitted :null,
    		emailStatus : null
         },
         masterList:{
        	 statusList:[],
        	 emailSentStatusList : [],
        	 isBatchCodeEditable:true
         },
         descretionList:[],
         selectedCrewBatch:null,
         isElasticLoadingVisible:false
    };

    vm.maxHeight = window.innerHeight - (70 + 42 + 40 + 80);
    
    EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);

    vm.clickOnSearch = function () {
        vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
        vm.model.initialSearchDone=false;
    };

    vm.searchByOptions = function(searchParams) {
    	setDefault();
    	vm.searchDiscretion();
    }

    vm.searchDiscretion = function() {
      vm.model.crewList = [];
      vm.model.searchCriteria.startPosition = 1;
      vm.model.initialSearchDone = true;
      searchCmdDiscretion();
    };

    function searchCmdDiscretion() {
        showLoader(true);
        AdminCommanderDiscretionService.setCrewBatchSearchCriteria(vm.model.searchCriteria);
        AdminCommanderDiscretionService.getCmdDescretions(
            function (descretionList,startPosition) {
                updateCmdDescretion(descretionList);
                updateGridSearchStartPosition(startPosition);
                vm.model.searchPanelToggle = false;
                showLoader(false);
                vm.model.searchOnGoing = false;
            },
            function (error) {
                MessageService.error(error);
                showLoader(false);
            }
        );
    }

    function getNextSetOfRecords() {
        vm.model.isElasticLoadingVisible = true;
        if(!vm.model.searchOnGoing){
        	vm.model.searchOnGoing = true;
        	searchCmdDiscretion();
        }
    }

    function setDefault() {
    	vm.model.searchCriteria.pageSize = 100;
        vm.model.searchCriteria.startPosition = 1;
        vm.model.masterList.statusList = AdminCommanderDiscretionService.searchStatusOptions();
        vm.model.masterList.emailSentStatusList = AdminCommanderDiscretionService.searchEmailSentStatus();
    }

    function updateCmdDescretion(descretionList) {
    	vm.model.descretionList = [];
        angular.forEach(descretionList, function (cmdDescretion) {
            vm.model.descretionList.push(cmdDescretion);
        });
        vm.model.isElasticLoadingVisible = false;
    }

    function showLoader(flag) {
        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
            flag: flag,
            target: 'adminCommanderDiscretion',
            animationName: 'crewing-loader'
        });
    }

    function updateGridSearchStartPosition(startPosition) {
    	 vm.model.searchCriteria.startPosition = startPosition;
    }

    vm.selectDescretion = function (selectedRowData) {
    	AdminCommanderDiscretionService.getCmndDescretionDetailSearchrequest(selectedRowData,
                function (responseData) {
                    showLoader(false);
                    loadPopup(responseData,selectedRowData);
                },
                function (error) {
                    MessageService.error(error);
                    showLoader(false);
                }
         );
  	};

  	function loadPopup(popupData,rowData) {
  	   var details = {"reportData":popupData,"generalData":rowData};
  	   PopupManager.openModal('SHOW_CMND_DESCRETION_SCORING', details, function(){});
  	}

    setDefault();


     var tabLocalData = StorageServices.getTabData('adminCommanderDiscretion');
      if (!!tabLocalData && !!tabLocalData.reportParam) {
        vm.model.searchCriteria.status =[];
        vm.model.searchCriteria.status.value = "PENDING_APPROVAL";
        vm.searchDiscretion();
      }


  }
}());
